import { PermissionKey, PermissionScope } from "@fitness-app/data-models";

import { usePermission } from "~/hooks/usePermission";

/**
 * Baza ćwiczeń jest wspólna dla całego tenanta, więc dopisuje do niej ten, kto
 * zarządza programami poza własnym przydziałem — nie „head coach" z roli.
 *
 * Ten sam warunek i ten sam tooltip stały wcześniej w dwóch miejscach
 * (`ExercisesDatabase`, `TrainingProgramAgent/ExerciseProposalCard`) jako
 * `isRegularTrainer`, przez co konta operacyjne z `programs.manage` nie mogły
 * dodać ćwiczenia, a komunikat odsyłał je do nieistniejącego head coacha.
 */
export const useCanEditExerciseLibrary = (): boolean =>
  usePermission(PermissionKey.PROGRAMS_MANAGE, PermissionScope.TEAM);

export const EXERCISE_LIBRARY_LOCKED_HINT =
  "Dodawanie ćwiczeń do wspólnej bazy wymaga uprawnienia do zarządzania programami. Zgłoś potrzebę osobie, która je ma.";
